import { Store } from './store'
import { Logic } from './logic/logic'

import { createContextRequired } from '../hooks/commonHooks'

export interface IAppContext {
  readonly store: Store

  readonly logic: Logic
}

export const AppContext =
  createContextRequired<IAppContext>()